import styled from '@emotion/styled';

import { typographyVariantStyles } from '@/shared/design-system/typography-variants';

export const PasswordRules = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
  margin: 0,
  padding: 0,
  listStyle: 'none',
}));

export const PasswordRule = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  color: theme.colors.text.tertiary,
  ...typographyVariantStyles.body3,

  '& svg': {
    flexShrink: 0,
    width: 16,
    height: 16,
    color: theme.colors.icon.secondary,
  },

  '&[data-met] svg': {
    color: theme.colors.success.text,
  },
}));
